import { getApiBaseUrl } from '../utils/urls';

export function fetchTodos() {
  return fetch(`${getApiBaseUrl()}/todos`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }).then((response) => {
    if (!response.ok) {
      throw new Error('Failed to fetch todos');
    }
    return response.json();
  });
}

export function createTodo(title, description) {
  return fetch(`${getApiBaseUrl()}/todos`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ title, description }),
  }).then((response) => {
    if (!response.ok) {
      throw new Error('Failed to create todo');
    }
    return response.json();
  });
}

export function deleteTodo(id) {
  return fetch(`${getApiBaseUrl()}/todos/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }).then((response) => {
    if (!response.ok) {
      throw new Error('Failed to delete todo');
    }
    return response.json();
  });
}
